import * as React from "react";

import { DateContext, DateContextType } from "./DateContext";

export const useDate = (): DateContextType => {
  const ctx = React.useContext(DateContext);

  if (!ctx) {
    throw new Error("useDate must be used under DateProvider");
  }

  return ctx;
};
